import Letterhead from './Letterhead';
import { fmtDMY } from '../lib/format';

export interface MaterialsSummaryLine { item: string; usedQty: number; condemnedQty: number }

/** Printable / PDF report: one row per distinct material name, totalling how much of it was
 * used and how much was condemned across every resolved complaint in range — the "how much
 * material got used" stock-consumption view, as opposed to the per-complaint report. */
export default function MaterialsSummaryDoc({ from, to, rows }: { from: string; to: string; rows: MaterialsSummaryLine[] }) {
  const totalUsed = rows.reduce((s, r) => s + r.usedQty, 0);
  const totalCondemned = rows.reduce((s, r) => s + r.condemnedQty, 0);
  return (
    <div className="print-area a4">
      <Letterhead />
      <div className="doc-head">
        <h2 className="doc-title">Material Consumption Summary</h2>
        <div className="doc-meta">
          <span>From: <strong>{fmtDMY(from)}</strong></span>
          <span>To: <strong>{fmtDMY(to)}</strong></span>
          <span>Materials: <strong>{rows.length}</strong></span>
        </div>
      </div>

      {rows.length === 0 ? (
        <p className="muted">No material usage recorded in this range.</p>
      ) : (
        <div className="tableScroll">
          <table className="grid paper">
            <thead>
              <tr>
                <th>Material</th>
                <th>Qty Used</th>
                <th>Qty Condemned</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.item}>
                  <td className="rmk">{r.item}</td>
                  <td>{r.usedQty || '—'}</td>
                  <td>{r.condemnedQty || '—'}</td>
                </tr>
              ))}
              <tr>
                <td className="rmk" style={{ fontWeight: 700 }}>Total</td>
                <td style={{ fontWeight: 700 }}>{totalUsed}</td>
                <td style={{ fontWeight: 700 }}>{totalCondemned}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      <div className="signrow"><div className="sign-ee">Electrical Engineer</div></div>
    </div>
  );
}
